/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Problem,
} from '../models/index';
import {
    ProblemFromJSON,
    ProblemToJSON,
} from '../models/index';

export interface StreamComparisonMatchingRequest {
    comparisonId: number;
}

export interface StreamDocumentExtractionRequest {
    documentId: number;
}

export interface StreamSupplementGenerationRequest {
    supplementId: number;
}

export interface StreamSupplementPdfExportRequest {
    supplementId: number;
}

/**
 * SSEApi - interface
 * 
 * @export
 * @interface SSEApiInterface
 */
export interface SSEApiInterface {
    /**
     * Establishes an SSE connection to stream real-time progress updates for comparison matching. The connection will remain open until matching completes, fails, or times out.  **Event Types:** - `progress` - Progress update with stage, percentage, and message - `completed` - Matching completed successfully - `failed` - Matching failed with error details - `heartbeat` - Keep-alive signal (every 30 seconds) - `error` - Server/connection error  **Note:** This endpoint returns `text/event-stream` content type. 
     * @summary Stream comparison matching progress
     * @param {number} comparisonId ID of the comparison to stream matching progress for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SSEApiInterface
     */
    streamComparisonMatchingRaw(requestParameters: StreamComparisonMatchingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Establishes an SSE connection to stream real-time progress updates for comparison matching. The connection will remain open until matching completes, fails, or times out.  **Event Types:** - `progress` - Progress update with stage, percentage, and message - `completed` - Matching completed successfully - `failed` - Matching failed with error details - `heartbeat` - Keep-alive signal (every 30 seconds) - `error` - Server/connection error  **Note:** This endpoint returns `text/event-stream` content type. 
     * Stream comparison matching progress
     */
    streamComparisonMatching(requestParameters: StreamComparisonMatchingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * Establishes an SSE connection to stream real-time progress updates for document extraction. The connection will remain open until the extraction completes, fails, or times out.  **Event Types:** - `progress` - Progress update with stage, percentage, and message - `completed` - Extraction completed successfully - `failed` - Extraction failed with error details - `heartbeat` - Keep-alive signal (every 30 seconds) - `error` - Server/connection error  **Note:** This endpoint returns `text/event-stream` content type. 
     * @summary Stream document extraction progress
     * @param {number} documentId ID of the document to stream extraction progress for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SSEApiInterface
     */
    streamDocumentExtractionRaw(requestParameters: StreamDocumentExtractionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Establishes an SSE connection to stream real-time progress updates for document extraction. The connection will remain open until the extraction completes, fails, or times out.  **Event Types:** - `progress` - Progress update with stage, percentage, and message - `completed` - Extraction completed successfully - `failed` - Extraction failed with error details - `heartbeat` - Keep-alive signal (every 30 seconds) - `error` - Server/connection error  **Note:** This endpoint returns `text/event-stream` content type. 
     * Stream document extraction progress
     */
    streamDocumentExtraction(requestParameters: StreamDocumentExtractionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * Establishes an SSE connection to stream real-time progress updates for supplement generation. The connection will remain open until generation completes, fails, or times out.  **Event Types:** - `progress` - Progress update with stage, percentage, and message - `completed` - Generation completed successfully - `failed` - Generation failed with error details - `heartbeat` - Keep-alive signal (every 30 seconds) - `error` - Server/connection error  **Note:** This endpoint returns `text/event-stream` content type. 
     * @summary Stream supplement generation progress
     * @param {number} supplementId ID of the supplement to stream generation progress for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SSEApiInterface
     */
    streamSupplementGenerationRaw(requestParameters: StreamSupplementGenerationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Establishes an SSE connection to stream real-time progress updates for supplement generation. The connection will remain open until generation completes, fails, or times out.  **Event Types:** - `progress` - Progress update with stage, percentage, and message - `completed` - Generation completed successfully - `failed` - Generation failed with error details - `heartbeat` - Keep-alive signal (every 30 seconds) - `error` - Server/connection error  **Note:** This endpoint returns `text/event-stream` content type. 
     * Stream supplement generation progress
     */
    streamSupplementGeneration(requestParameters: StreamSupplementGenerationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * Establishes an SSE connection to stream real-time progress updates for supplement PDF export. The connection will remain open until the PDF is ready, export fails, or times out.  **Event Types:** - `pdf_ready` - PDF generation completed, includes download URL - `heartbeat` - Keep-alive signal (every 30 seconds) - `error` - Server/connection error  **Note:** This endpoint returns `text/event-stream` content type. The connection automatically closes after the PDF is ready. 
     * @summary Stream supplement PDF export progress
     * @param {number} supplementId ID of the supplement to stream PDF export progress for
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SSEApiInterface
     */
    streamSupplementPdfExportRaw(requestParameters: StreamSupplementPdfExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Establishes an SSE connection to stream real-time progress updates for supplement PDF export. The connection will remain open until the PDF is ready, export fails, or times out.  **Event Types:** - `pdf_ready` - PDF generation completed, includes download URL - `heartbeat` - Keep-alive signal (every 30 seconds) - `error` - Server/connection error  **Note:** This endpoint returns `text/event-stream` content type. The connection automatically closes after the PDF is ready. 
     * Stream supplement PDF export progress
     */
    streamSupplementPdfExport(requestParameters: StreamSupplementPdfExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

}

/**
 * 
 */
export class SSEApi extends runtime.BaseAPI implements SSEApiInterface {

    /**
     * Establishes an SSE connection to stream real-time progress updates for comparison matching. The connection will remain open until matching completes, fails, or times out.  **Event Types:** - `progress` - Progress update with stage, percentage, and message - `completed` - Matching completed successfully - `failed` - Matching failed with error details - `heartbeat` - Keep-alive signal (every 30 seconds) - `error` - Server/connection error  **Note:** This endpoint returns `text/event-stream` content type. 
     * Stream comparison matching progress
     */
    async streamComparisonMatchingRaw(requestParameters: StreamComparisonMatchingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['comparisonId'] == null) {
            throw new runtime.RequiredError(
                'comparisonId',
                'Required parameter "comparisonId" was null or undefined when calling streamComparisonMatching().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/sse/comparisons/{comparisonId}/matching`.replace(`{${"comparisonId"}}`, encodeURIComponent(String(requestParameters['comparisonId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Establishes an SSE connection to stream real-time progress updates for comparison matching. The connection will remain open until matching completes, fails, or times out.  **Event Types:** - `progress` - Progress update with stage, percentage, and message - `completed` - Matching completed successfully - `failed` - Matching failed with error details - `heartbeat` - Keep-alive signal (every 30 seconds) - `error` - Server/connection error  **Note:** This endpoint returns `text/event-stream` content type. 
     * Stream comparison matching progress
     */
    async streamComparisonMatching(requestParameters: StreamComparisonMatchingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.streamComparisonMatchingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Establishes an SSE connection to stream real-time progress updates for document extraction. The connection will remain open until the extraction completes, fails, or times out.  **Event Types:** - `progress` - Progress update with stage, percentage, and message - `completed` - Extraction completed successfully - `failed` - Extraction failed with error details - `heartbeat` - Keep-alive signal (every 30 seconds) - `error` - Server/connection error  **Note:** This endpoint returns `text/event-stream` content type. 
     * Stream document extraction progress
     */
    async streamDocumentExtractionRaw(requestParameters: StreamDocumentExtractionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['documentId'] == null) {
            throw new runtime.RequiredError(
                'documentId',
                'Required parameter "documentId" was null or undefined when calling streamDocumentExtraction().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/sse/documents/{documentId}/extraction`.replace(`{${"documentId"}}`, encodeURIComponent(String(requestParameters['documentId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Establishes an SSE connection to stream real-time progress updates for document extraction. The connection will remain open until the extraction completes, fails, or times out.  **Event Types:** - `progress` - Progress update with stage, percentage, and message - `completed` - Extraction completed successfully - `failed` - Extraction failed with error details - `heartbeat` - Keep-alive signal (every 30 seconds) - `error` - Server/connection error  **Note:** This endpoint returns `text/event-stream` content type. 
     * Stream document extraction progress
     */
    async streamDocumentExtraction(requestParameters: StreamDocumentExtractionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.streamDocumentExtractionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Establishes an SSE connection to stream real-time progress updates for supplement generation. The connection will remain open until generation completes, fails, or times out.  **Event Types:** - `progress` - Progress update with stage, percentage, and message - `completed` - Generation completed successfully - `failed` - Generation failed with error details - `heartbeat` - Keep-alive signal (every 30 seconds) - `error` - Server/connection error  **Note:** This endpoint returns `text/event-stream` content type. 
     * Stream supplement generation progress
     */
    async streamSupplementGenerationRaw(requestParameters: StreamSupplementGenerationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['supplementId'] == null) {
            throw new runtime.RequiredError(
                'supplementId',
                'Required parameter "supplementId" was null or undefined when calling streamSupplementGeneration().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/sse/supplements/{supplementId}/generation`.replace(`{${"supplementId"}}`, encodeURIComponent(String(requestParameters['supplementId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Establishes an SSE connection to stream real-time progress updates for supplement generation. The connection will remain open until generation completes, fails, or times out.  **Event Types:** - `progress` - Progress update with stage, percentage, and message - `completed` - Generation completed successfully - `failed` - Generation failed with error details - `heartbeat` - Keep-alive signal (every 30 seconds) - `error` - Server/connection error  **Note:** This endpoint returns `text/event-stream` content type. 
     * Stream supplement generation progress
     */
    async streamSupplementGeneration(requestParameters: StreamSupplementGenerationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.streamSupplementGenerationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Establishes an SSE connection to stream real-time progress updates for supplement PDF export. The connection will remain open until the PDF is ready, export fails, or times out.  **Event Types:** - `pdf_ready` - PDF generation completed, includes download URL - `heartbeat` - Keep-alive signal (every 30 seconds) - `error` - Server/connection error  **Note:** This endpoint returns `text/event-stream` content type. The connection automatically closes after the PDF is ready. 
     * Stream supplement PDF export progress
     */
    async streamSupplementPdfExportRaw(requestParameters: StreamSupplementPdfExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['supplementId'] == null) {
            throw new runtime.RequiredError(
                'supplementId',
                'Required parameter "supplementId" was null or undefined when calling streamSupplementPdfExport().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/sse/supplements/{supplementId}/pdf-export`.replace(`{${"supplementId"}}`, encodeURIComponent(String(requestParameters['supplementId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Establishes an SSE connection to stream real-time progress updates for supplement PDF export. The connection will remain open until the PDF is ready, export fails, or times out.  **Event Types:** - `pdf_ready` - PDF generation completed, includes download URL - `heartbeat` - Keep-alive signal (every 30 seconds) - `error` - Server/connection error  **Note:** This endpoint returns `text/event-stream` content type. The connection automatically closes after the PDF is ready. 
     * Stream supplement PDF export progress
     */
    async streamSupplementPdfExport(requestParameters: StreamSupplementPdfExportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.streamSupplementPdfExportRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
